import { Grid, TextField } from "@mui/material"
import { Controller, UseFormReturn } from "react-hook-form"
import EvesSelect from "@/common/components/atoms/select/select"
import { useTranslation } from "react-i18next"
import { getRefundSettings } from "@/services/integrationSettings"
import { useQuery } from "react-query"
import { getComponentValueSafe } from "@/common/utils/componentListHelper"
import { useEffect, useState } from "react"
import { ComponentKeys } from "@/common/enums/enums"
interface ILimitsPropsModel {
  siteAreaForm: UseFormReturn<any, any>
  isDisabled: boolean
}

export default function EvConnector(props: ILimitsPropsModel) {
  const { control } = props.siteAreaForm
  const { t: translate } = useTranslation()
  const [connectionNames, setConnectionNames] = useState<any[]>([])

  const carConnectorParams = () => {
    return {
      Identifier: getComponentValueSafe(ComponentKeys.CAR_CONNECTOR),
      SortFields: "-+name",
      Limit: 50,
      Page: 1
    }
  }

  useEffect(() => {
    fetchCarConnectorSettings()
  }, [])

  const { refetch: fetchCarConnectorSettings } = useQuery(
    "CarConnectorSettings",
    () => {
      return getRefundSettings(carConnectorParams())
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      enabled: false,
      onSuccess: async (res: any) => {
        if (res) {
          const data = { ...res?.setting?.content?.carConnector }
          if (data?.connections && data?.connections?.length > 0) {
            const connections: any = []
            data?.connections.map((connection: any) => {
              const items = {
                label: connection.name,
                value: connection.name
              }
              connections.push(items)
            })
            setConnectionNames(connections)
          }
        }
      },
    }
  )

  return (
    <>
      <Grid container direction="row" rowSpacing={1} columnSpacing={2}>
        <Grid item xs={4}>
          <Controller
            name="connectionName"
            control={control}
            render={({ field }) => (
              <EvesSelect
                data-cy="voltage-option"
                label={`${translate("cars.car_connector_name")}`}
                options={connectionNames}
                {...field}
                onChange={(event: any) => {
                  field.onChange(event)
                }}
                disabled={props.isDisabled}
              />
            )}
          />
        </Grid>
        <Grid item xs={8} />
        <Grid item xs={4}>
          <Controller
            name="connectorMeterId"
            control={props.siteAreaForm.control}
            render={({ field }) => (
              <TextField
                {...field}
                onChange={(event) => {
                  field.onChange(event)
                }}
                id="connectorMeterId"
                label={`${translate("cars.car_connector_meter_id")}`}
                type="number"
                fullWidth
                variant="standard"
                disabled={props.isDisabled}
              />
            )}
          />
        </Grid>
      </Grid>
    </>
  )
}
